module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "para-style-override-1"
  }, [_c('img', {
    attrs: {
      "alt": "Brunhilde_037.tif",
      "height": "479",
      "src": "images/Brunhilde_037_fmt.jpg",
      "width": "395"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "Introduction",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Introduction-Project-Title char-style-override-7",
    staticStyle: {
      "font-size": "0.78em"
    }
  }, [_vm._v("Introduction ")])]), _vm._v(" "), _c('p', {
    staticClass: "Introduction",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Introduction-Body-Copy",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("When the possibility of writing a book of new mitten and glove patterns was presented to me, I was immediately intrigued as I consider myself a mitten and glove aficionado of sorts. I grew up in Cape Breton, on Canada’s Atlantic coast, where winters tend to be harsh and mittens and gloves are essential in everyone’s wardrobes. I recognized right away that this would be a wonderful opportunity for me to explore new avenues of design and to share my enthusiasm for these humble items.")])]), _vm._v(" "), _c('p', {
    staticClass: "No-Paragraph-Style para-style-override-4",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "char-style-override-13"
  })]), _vm._v(" "), _c('p', {
    staticClass: "No-Paragraph-Style para-style-override-4",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "char-style-override-14"
  }, [_vm._v("Like many knitters, I am especially drawn to mittens and gloves because they are useful, generally quick to make, small enough to carry around while being worked on and to work on even in warm weather without discomfort, and don’t require a lot of yarn. They are also a great project on which to experiment—to try out new techniques or yarns that can be applied later to larger endeavors. Since I prefer not to knit the same project over and over again, I’m always stimulated by a fresh challenge and by the opportunity to view something familiar with a new perspective. When I accepted the opportunity to work on this book, I set the following goal: to redefine how mittens and gloves are made and worn by experimenting with and mixing and matching traditional and nontraditional techniques and influences. On the pages that follow are the results. For example, on "), _c('a', {
    attrs: {
      "href": "#/section#negativeSpace"
    }
  }, [_vm._v("page 91")]), _vm._v(" is Negative Space, a design inspired by a unique but rarely seen Norwegian folk mitten with a cutaway palm. On "), _c('a', {
    attrs: {
      "href": "#/section#standardDeviation"
    }
  }, [_vm._v("page 115")]), _vm._v(" is Standard Deviation, influenced by a combination of the hotel carpeting in the horror movie ")]), _c('span', {
    staticClass: "Project-Body-copy-Italic char-style-override-15"
  }, [_vm._v("The Shining")]), _c('span', {
    staticClass: "char-style-override-14"
  }, [_vm._v(" and my love of stranded colorwork and Norwegian wool. For Gothic on "), _c('a', {
    attrs: {
      "href": "#/section#gothic"
    }
  }, [_vm._v("page 73")]), _vm._v(", I challenged the utilitarian boundary of the glove: This design is intended as a purely decorative accessory rather than a winter essential. ")])]), _vm._v(" "), _c('p', {
    staticClass: "No-Paragraph-Style para-style-override-4",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('p', {
    staticClass: "No-Paragraph-Style para-style-override-4",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "char-style-override-14"
  }, [_vm._v("As you may have already guessed by scanning the project list on "), _c('a', {
    attrs: {
      "href": "#/Contents"
    }
  }, [_vm._v("page 4")]), _vm._v(" or the photos or descriptive passages throughout the book, I have a passion for Celtic language and art that always seems to make its way to the surface, whether it is the direct inspiration for a design")]), _c('span', {
    staticClass: "char-style-override-14"
  }, [_vm._v("—")]), _c('span', {
    staticClass: "char-style-override-14"
  }, [_vm._v("like Golden Bracelets "), _c('a', {
    attrs: {
      "href": "#/section#goldenBracelets"
    }
  }, [_vm._v("(page 69)")]), _vm._v(" or Ceangaltas "), _c('a', {
    attrs: {
      "href": "#/section#ceangaltas"
    }
  }, [_vm._v("(page 41)")])]), _c('span', {
    staticClass: "char-style-override-14"
  }, [_vm._v("—")]), _c('span', {
    staticClass: "char-style-override-14"
  }, [_vm._v("or an influence in my choice of colors, buttons, or project names. I have also spent a lot of time reading medieval European literature, Norse and Icelandic sagas, and Early Irish heroic cycles. Often I am inspired by a name, a character, or an interesting description, or even just by thinking about a particular era in history. I follow fashion with interest but not slavishly; I pay the most attention to avant-garde runway shows with models sprouting antlers or donning designs incorporating futuristic shapes with intricate hand-finished details. While these interests do not always translate directly into my knitting, they do inform my outlook on design and my general aesthetic. ")])]), _vm._v(" "), _c('p', {
    staticClass: "No-Paragraph-Style para-style-override-4",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "char-style-override-14"
  })]), _vm._v(" "), _c('p', {
    staticClass: "No-Paragraph-Style para-style-override-4",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "char-style-override-14"
  }, [_vm._v("As I began the adventure of designing the projects for this book, I recalled reading in the science-fiction novel ")]), _c('span', {
    staticClass: "Project-Body-copy-Italic char-style-override-15"
  }, [_vm._v("The Terminal Experiment")]), _c('span', {
    staticClass: "char-style-override-14"
  }, [_vm._v(" by Robert. J. Sawyer that the funniest jokes are created when an unexpected association causes the brain to generate a new pathway, which translates as humor. I think the same is true when creating new knitwear designs: An inventive combination of familiar styles and materials produces a sense of freshness and originality that may not have been evident within any of the components individually. I think you will find that the designs that follow are fresh but not faddish, unusual but not outlandish. They are grounded in history and technique, but each has some new element or combination wrought into it. I hope that working on these mittens and gloves will inspire in you an ever-increasing ")]), _c('span', {
    staticClass: "char-style-override-14"
  }, [_vm._v("fondness for and fascination with them. That is certainly how designing and knitting them has rewarded ")]), _c('span', {
    staticClass: "char-style-override-14"
  }, [_vm._v("me.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-698ac5f1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/introduction.vue
// module id = 69
// module chunks = 0